// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: 'AIzaSyB5vin0RR2BAAQzs6rgwdVYcxFU3sCs4hE',
    authDomain: 'chatapp-react-jen.firebaseapp.com',
    projectId: 'chatapp-react-jen',
    storageBucket: 'chatapp-react-jen.appspot.com',
    messagingSenderId: '383271332703',
    appId: '1:383271332703:web:f0e5921b18c42ba69da4ea',
    measurementId: 'G-9FK3TQVP16',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const db = getFirestore(app);
